// extracted by mini-css-extract-plugin
export default {"desc":"ExptSolution_desc__CGwaL","cards":"ExptSolution_cards__rKbk6"};